import { render } from "./MapLegendGradient.vue?vue&type=template&id=0dd7e72e&scoped=true&ts=true"
import script from "./MapLegendGradient.vue?vue&type=script&lang=ts"
export * from "./MapLegendGradient.vue?vue&type=script&lang=ts"

import "./MapLegendGradient.vue?vue&type=style&index=0&id=0dd7e72e&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd7e72e"]])

export default __exports__